import { ThemeProvider, createTheme } from "@mui/material";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import Loading from "./components/Loading/Loading";
import "./i18n";
import "./index.css";

const theme = createTheme({
  palette: {
    primary: {
      main: "#E94F11",
      dark: "#E94F11",
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Suspense fallback={<Loading height={true} />}>
        <ThemeProvider theme={theme}>
          {/* <LocalizationProvider dateAdapter={AdapterDayjs}> */}
          <Routes />
          {/* </LocalizationProvider> */}
        </ThemeProvider>
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>
);
